import { render, staticRenderFns } from "./LocalAllocationOrders.vue?vue&type=template&id=015db4c4&"
import script from "./LocalAllocationOrders.vue?vue&type=script&lang=js&"
export * from "./LocalAllocationOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015db4c4')) {
      api.createRecord('015db4c4', component.options)
    } else {
      api.reload('015db4c4', component.options)
    }
    module.hot.accept("./LocalAllocationOrders.vue?vue&type=template&id=015db4c4&", function () {
      api.rerender('015db4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/LocalAllocationOrders.vue"
export default component.exports